import { useState } from "react";

import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useNotificationContext } from "providers";
import { ENDPOINTS, NormalizedError } from "services";
import { LinkButton } from "ui";
import { downloadFileBlob, parseErrorMessage } from "utils";

import { ReactComponent as DownloadIcon } from "images/downloadIcon.svg";

import styles from "./detailReport.module.css";
import { Flex, Typography } from "antd";

interface IProps {
  checkId: string;
  type: "wallet" | "tx";
}

export const DetailReportButton = (props: IProps) => {
  const { checkId, type } = props;

  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const handleDownloadReport = async () => {
    setLoading(true);
    try {
      if (type === "tx") {
        await downloadFileBlob(ENDPOINTS.manualCheckReport(checkId), true);
      } else {
        await downloadFileBlob(ENDPOINTS.walletCheckReport(checkId), true);
      }
    } catch (e: unknown) {
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.ERROR,
        description: parseErrorMessage(e as NormalizedError),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <LinkButton onClick={handleDownloadReport} disabled={loading}>
      <Flex align="center" gap={4}>
        {/* <Typography.Text underline>Скачать</Typography.Text> */}
        <DownloadIcon className={`${styles.downloadIcon} cursor-pointer`} />
      </Flex>
    </LinkButton>
  );
};
